<template>
  <div class="tabbar">
    <template v-for="item in tabs" :key="item.name">
      <!-- 外部链接 -->
      <div
        v-if="item.isExternal"
        class="tabbar-center"
        @click="handleTabClick(item)"
      >
        <img
          :src="active === item.name ? item.activeIcon : item.icon"
          class="tabbar-icon"
          :alt="item.label || '外部链接'"
        />
        <span :class="{ active: active === item.name }">{{ item.label }}</span>
      </div>

      <!-- 内部路由 -->
      <router-link
        v-else
        :to="item.link"
        class="tabbar-item"
        @click="handleTabClick(item)"
      >
        <img
          :src="active === item.name ? item.activeIcon : item.icon"
          class="tabbar-icon"
          :alt="item.label"
        />
        <span :class="{ active: active === item.name }">{{ item.label }}</span>
      </router-link>
    </template>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

import homeIcon from "@/assets/home.png";
import homeIconActive from "@/assets/home_sel.png";
import activeIcon from "@/assets/active.png";
import activeIconActive from "@/assets/active_sel.png";
import giftIcon from "@/assets/shop.png";
import giftIconActive from "@/assets/shop_sel.png";
import mineIcon from "@/assets/mine.png";
import mineIconActive from "@/assets/mine_sel.png";
import paperIcon from "@/assets/nav_logo2.png";

const tabs = computed(() => [
  {
    name: "home",
    label: "首页",
    link: "/",
    icon: homeIcon,
    activeIcon: homeIconActive,
  },
  {
    name: "active",
    label: "活动",
    link: "/active",
    icon: activeIcon,
    activeIcon: activeIconActive,
  },
  {
    name: "paper",
    label: "",
    link: `https://news.xinmin.cn/zt/xmdy/index.html`,
    icon: paperIcon,
    activeIcon: paperIcon,
    isExternal: true,
  },
  {
    name: "Shop",
    label: "积分",
    link: "/shop",
    icon: giftIcon,
    activeIcon: giftIconActive,
  },
  {
    name: "mine",
    label: "我的",
    link: "/mine",
    icon: mineIcon,
    activeIcon: mineIconActive,
  },
]);

const active = ref("home");

const handleTabClick = (item) => {
  // 无论内部路由还是外部链接，都先更新active状态
  active.value = item.name;

  // 如果是外部链接，单独处理跳转
  if (item.isExternal) {
    window.open(item.link, "_blank");
  }
};

// 监听路由变化，更新active状态
watch(
  () => route.path,
  (newPath) => {
    // tabs 是 computed/ref，要用 .value
    const matchedTab = tabs.value.find(
      (item) => !item.isExternal && newPath === item.link
    );

    if (matchedTab) {
      active.value = matchedTab.name;
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(10vh + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  padding-right: 5%;
  padding-left: 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-top: 1px solid #eee;
  z-index: 1000;
  box-sizing: border-box;
}

.tabbar-item {
  flex: 1;
  text-align: center;
  font-size: 0.75rem;
  color: #353535;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tabbar-item .tabbar-icon {
  width: 6vw;
  margin-bottom: 0.2rem;
  object-fit: contain;
}

.tabbar-item span.active {
  color: #ff655f;
}

.tabbar-center {
  width: 25%;
  border-radius: 50%;
  margin: -10vw auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 1rem;
  color: #666;
  z-index: 1001;
  box-sizing: border-box;
}

.tabbar-center img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  margin-bottom: 0;
  object-fit: contain;
}
</style>
